import { factorialTipEvents } from 'modules/core/lib/events'
import { eventsEvents } from 'modules/core/lib/events'
import { commsEvents } from 'modules/core/lib/events'
import { discoveryModalEvents } from 'modules/core/lib/events'
import { events as activityLogEvents } from 'modules/core/lib/events/ActivityLog/events'

import { events as approvalsEvents } from 'modules/approvals/lib/events'
import { events as atsEvents } from 'modules/ats/lib/events'
import { attendanceEvents } from 'modules/attendance/lib/events'
import { timeTrackingEvents } from 'modules/attendance/lib/events'
import { events as benefitsEvents } from 'modules/benefits/lib/events'
import { events as billingEvents } from 'modules/billing/lib/events'
import { events as bookkeeperEvents } from 'modules/bookkeepers/lib/events'
import { events as companyPageEvents } from 'modules/company_page/lib/events'
import { events as compensationsEvents } from 'modules/compensations/lib/events'
import { events as competenciesEvents } from 'modules/competencies/lib/events'
import { events as dashboardEvents } from 'modules/dashboard/lib/events'
import {
  addEmployeeEvents,
  bulkActivateEvents,
  bulkPauseEvents,
  bulkTerminationEvents,
  editEmployeesInBulkEvents,
  employeeEvents,
  fixAgreementInBulkEvents,
  importContractsEvents,
  importEmployeesEvents,
  oldImportEmployeesEvents,
} from 'modules/employees/lib/events'
import { events as engagementEvents } from 'modules/engagement/lib/events'
import { events as engagementInsightsEvents } from 'modules/engagement_insights/lib/events'
import { events as enpsEvents } from 'modules/enps/lib/events'
import { events as expensesEvents } from 'modules/expenses/lib/events'
import { events as accountingEvents } from 'modules/finance/lib/events'
import { events as inAppCommsEvents } from 'modules/in_app_comms/lib/events'
import { events as inboxTasksEvents } from 'modules/inbox_tasks/lib/events'
import { events as insightsEvents } from 'modules/insights/lib/events'
import { events as itManagementEvents } from 'modules/it_management/lib/events'
import { events as jobCatalogEvents } from 'modules/job_catalog/lib/events'
import { events as kudosV2Events } from 'modules/kudos/lib/events'
import { locationEvents } from 'modules/locations/lib/events'
import { workAreasEvents } from 'modules/locations/lib/events'
import { events as marketplaceEvents } from 'modules/marketplace/lib/events'
import { events as marketplaceModulesEvents } from 'modules/marketplace_modules/lib/events'
import { events as meetingsEvents } from 'modules/meetings/lib/events'
import { events as inboxEvents } from 'modules/notifications/lib/events'
import { events as npsEvents } from 'modules/nps/lib/events'
import { events as onboardingEvents } from 'modules/onboarding/lib/events'
import { events as oneOnOnesEvents } from 'modules/one_on_ones/lib/events'
import { events as orgChartEvents } from 'modules/org_chart/lib/events'
import { events as payrollEvents } from 'modules/payroll_bundle/lib/events'
import { events as payrollIntegrationsA3InnuvaEvents } from 'modules/payroll_integrations_a3innuva/lib/events'
import { events as payrollIntegrationsDatevLaudsEvents } from 'modules/payroll_integrations_datev_lauds/lib/events'
import { events as teamChartEvents } from 'modules/people_chart/lib/events'
import { events as performanceAnalyticsEvents } from 'modules/performance_analytics/lib/events'
import { events as performanceCyclesEvents } from 'modules/performance_cycles/lib/events'
import { events as performanceFeedbacksEvents } from 'modules/performance_feedbacks/lib/events'
import { events as performanceGoalsEvents } from 'modules/performance_goals/lib/events'
import { events as performanceProcessEvents } from 'modules/performance_process/lib/events'
import { events as permissionsEvents } from 'modules/permissions/lib/events'
import { events as communitiesEvents } from 'modules/posts/lib/events'
import { events as processesEvents } from 'modules/processes/lib/events'
import { procurementEvents } from 'modules/procurement/lib/events'
import { events as productUpdatesEvents } from 'modules/product_updates/lib/events'
import { events as profileEvents } from 'modules/profile/lib/events'
import { events as projectManagementEvents } from 'modules/project_management/lib/events'
import { events as reportsEvents } from 'modules/reports/lib/events'
import { events as securityEvents } from 'modules/security_settings/lib/events'
import { events as settingsEvents } from 'modules/settings/lib/events'
import { events as shiftManagementEvents } from 'modules/shift_management/lib/events'
import { events as softwareManagementEvents } from 'modules/software_management/lib/events'
import { events as spaceControlEvents } from 'modules/space_control/lib/events'
import { events as surveysEvents } from 'modules/surveys/lib/events'
import { events as taskEvents } from 'modules/tasks/lib/events'
import { events as teamsEvents } from 'modules/teams/lib/events'
import { events as timeSettingsEvents } from 'modules/time_categories_settings/lib/events'
import { events as timePlanningEvents } from 'modules/time_planning/lib/events'
import { events as timeoffEvents } from 'modules/timeoff/lib/events'
import { trainingEvents } from 'modules/trainings/lib/events'
import { events as universalExportEvents } from 'modules/universal_exports/lib/events'
import { events as universalImporterEvents } from 'modules/universal_importer/lib/events'
import { events as upsellEvents } from 'modules/upsell/lib/events'
import { events as upsellingKitEvents } from 'modules/upselling_kit/lib/events'

export const trackingEvents = {
  accounting: accountingEvents,
  activityLog: activityLogEvents,
  addEmployee: addEmployeeEvents,
  approvals: approvalsEvents,
  ats: atsEvents,
  attendance: attendanceEvents,
  billing: billingEvents,
  bookkeeper: bookkeeperEvents,
  comms: commsEvents,
  communities: communitiesEvents,
  competencies: competenciesEvents,
  compensations: compensationsEvents,
  companyPage: companyPageEvents,
  dashboard: dashboardEvents,
  discoveryModal: discoveryModalEvents,
  employee: employeeEvents,
  engagement: engagementEvents,
  engagementInsights: engagementInsightsEvents,
  enps: enpsEvents,
  events: eventsEvents,
  expenses: expensesEvents,
  factorialTip: factorialTipEvents,
  inAppComms: inAppCommsEvents,
  inbox: inboxEvents,
  insights: insightsEvents,
  itManagement: itManagementEvents,
  importEmployees: importEmployeesEvents,
  importContracts: importContractsEvents,
  editEmployeesInBulk: editEmployeesInBulkEvents,
  softwareManagement: softwareManagementEvents,
  jobCatalog: jobCatalogEvents,
  location: locationEvents,
  marketplace: marketplaceEvents,
  marketplaceModules: marketplaceModulesEvents,
  nps: npsEvents,
  onboarding: onboardingEvents,
  one_on_ones: oneOnOnesEvents,
  orgChart: orgChartEvents,
  payroll: payrollEvents,
  performanceAnalytics: performanceAnalyticsEvents,
  performanceCycles: performanceCyclesEvents,
  performanceFeedbacks: performanceFeedbacksEvents,
  performanceGoals: performanceGoalsEvents,
  performanceProcess: performanceProcessEvents,
  permissions: permissionsEvents,
  processes: processesEvents,
  procurement: procurementEvents,
  profile: profileEvents,
  projectManagement: projectManagementEvents,
  reports: reportsEvents,
  security: securityEvents,
  settings: settingsEvents,
  shiftManagement: shiftManagementEvents,
  spaceControl: spaceControlEvents,
  surveys: surveysEvents,
  tasks: taskEvents,
  inboxTasks: inboxTasksEvents,
  teams: teamsEvents,
  timeoff: timeoffEvents,
  timePlanning: timePlanningEvents,
  timeTracking: timeTrackingEvents,
  timeSettings: timeSettingsEvents,
  training: trainingEvents,
  productUpdates: productUpdatesEvents,
  universalExport: universalExportEvents,
  upsell: upsellEvents,
  upsellingKit: upsellingKitEvents,
  kudosV2Events: kudosV2Events,
  workAreas: workAreasEvents,
  teamChart: teamChartEvents,
  payrollIntegrationsA3Innuva: payrollIntegrationsA3InnuvaEvents,
  payrollIntegrationsDatevLauds: payrollIntegrationsDatevLaudsEvents,
  oldImportEmployees: oldImportEmployeesEvents,
  bulkTermination: bulkTerminationEvents,
  bulkPause: bulkPauseEvents,
  bulkActivate: bulkActivateEvents,
  fixAgreementInBulk: fixAgreementInBulkEvents,
  benefits: benefitsEvents,
  universalImporter: universalImporterEvents,
  meetings: meetingsEvents,
}
